export default {
  how_to_place_order: {
    header: 'Jak złożyć zamówienie?',
    body: 'Przeglądaj menu, dodaj produkty do koszyka i postępuj zgodnie z krokami kasy. Po złożeniu zamówienia otrzymasz potwierdzenie.',
  },
  schedule_order: {
    header: 'Czy mogę zaplanować zamówienie z wyprzedzeniem?',
    body: 'Tak! Przy kasie wybierz opcję „Zaplanuj", aby ustawić przyszłą godzinę odbioru.',
  },
  customize_order: {
    header: 'Czy mogę spersonalizować zamówienie?',
    body: 'Oczywiście. Dotknij pozycji w menu, aby zobaczyć opcje personalizacji, takie jak dodatki i preferencje.',
  },
  track_order: {
    header: 'Jak śledzić moje zamówienie?',
    body: 'Po złożeniu zamówienia zobaczysz aktualizacje w czasie rzeczywistym — od potwierdzenia do przygotowania i gotowości do odbioru.',
  },
  cancel_or_edit_order: {
    header: 'Czy mogę anulować lub edytować zamówienie po złożeniu?',
    body: 'Jeśli przygotowanie zamówienia jeszcze się nie rozpoczęło, możesz poprosić o zmiany, dzwoniąc bezpośrednio do restauracji przez aplikację.',
  },
  payment_methods: {
    header: 'Jakie metody płatności akceptujecie?',
    body: 'Akceptujemy główne karty kredytowe/debetowe, Apple Pay i Google Pay, w zależności od urządzenia.',
  },
  no_confirmation: {
    header: 'Nie dotarło do mnie potwierdzenie. Co mam zrobić?',
    body: 'Sprawdź folder spam lub przejdź do zakładki Zamówienia w aplikacji. Jeśli nadal go nie widzisz, skontaktuj się bezpośrednio z restauracją.',
  },
  pickup_instructions: {
    header: 'Gdzie odbieram zamówienie?',
    body: 'Instrukcje odbioru są na ekranie potwierdzenia i w podsumowaniu zamówienia. Poszukaj oznaczeń lub zapytaj personelu po przybyciu.',
  },
  loyalty_points: {
    header: 'Czy mogę zbierać punkty lojalnościowe za zamówienia?',
    body: 'Tak, kwalifikujące się zakupy automatycznie naliczają punkty. Saldo i nagrody zobaczysz na głównym ekranie aplikacji.',
  },
  apply_promo_code: {
    header: 'Jak zastosować kod promocyjny lub zniżkę?',
    body: 'Podczas kasy zobaczysz opcję wpisania kodu promocyjnego. Dostępne zniżki są też stosowane automatycznie, jeśli spełniasz warunki.',
  },
  issue_with_order: {
    header: 'Co zrobić w razie problemu z zamówieniem?',
    body: 'Jesteśmy tu, aby pomóc. Skontaktuj się z restauracją przez aplikację lub użyj opcji Kontakt z pomocą techniczną.',
  },
  use_loyalty_and_coupon: {
    header: 'Czy mogę użyć punktów lojalnościowych i kuponu (np. Kup 1, Drugi Gratis) na to samo zamówienie?',
    body: 'Nie — na jedno zamówienie można zastosować tylko jedną zniżkę lub ofertę. Dzięki temu nagrody i promocje są uczciwie wykorzystywane. Wybierz opcję, która daje Ci największą wartość!',
  },
};
